(function () {
  const host = Shopify.shop;
  const options = {
    "owner-club.myshopify.com": {
      basePath: "https://api2.speediance.top/api2/app/third/dtc/",
      apiAuthKey: "AYUC46N480DCM3M",
      shopifyStoresFlag: host,
      //日语
      acceptLanguage: "en",
    },
    "bc91e5-2b.myshopify.com": {
      basePath: "https://api2.speediance.com/api/app/third/dtc/",
      apiAuthKey: "AYUC46N480DCM3M",
      shopifyStoresFlag: host,
      //英语
      acceptLanguage: "en",
    },
    "b66830-2.myshopify.com": {
      basePath: "https://euapi.speediance.com/api/app/third/dtc/",
      apiAuthKey: "AYUC46N480DCM3M",
      shopifyStoresFlag: host,
      //德语
      acceptLanguage: "de",
    },
    "214d1e-7a.myshopify.com": {
      basePath: "https://api2.speediance.com/api/app/third/dtc/",
      apiAuthKey: "AYUC46N480DCM3M",
      shopifyStoresFlag: host,
      acceptLanguage: "ja-JP",
    },
    // TODO 5个站点配置
  };
  // if (fetch) {
  const LoyaltyFetch = (requestOpt) => {
    // requestOpt: {path, method, body}

    // let env = "test";
    // if (!(host.indexOf() == -1 || host.indexOf("localhost") == -1)) {
    //   env = host.split(".")?.[0];
    // }

    const { basePath, apiAuthKey, shopifyStoresFlag, acceptLanguage } = options[host];
    const { body } = requestOpt;
    let reqBody = body ? body : {};
    reqBody = { shopifyStoresFlag, shopifyUserId: getCustomerId(), ...reqBody };

    return fetch(basePath + requestOpt.path, {
      method: requestOpt.method || "POST", // 后端提供的接口都是POST，所以默认POST
      body: JSON.stringify(reqBody),
      headers: new Headers({
        "Content-Type": "application/json",
        apiAuthKey,
        "Accept-Language": acceptLanguage || "en",
      }),
      mode: "cors",
    });
  };

  function getCustomerId() {
    const dom = document.querySelector("#loyalty-customer-id");
    if (dom) {
      const customerId = dom.getAttribute("data-customer-id");
      console.log('customerId', customerId);
      if (customerId) return customerId;
    }
    try {
      if (window.customerId) {
        console.log('window.customerId', window.customerId);
        return window.customerId;
      }
    } catch (e) {}
    try {
      let curr = window.ShopifyAnalytics.meta.page.customerId;
      if (curr !== undefined && curr !== null && curr !== "") {
        console.log('ShopifyAnalytics.meta.page.customerId', curr);
        return curr;
      }
    } catch (e) {}
    try {
      let curr = window.meta.page.customerId;
      if (curr !== undefined && curr !== null && curr !== "") {
        console.log('meta.page.customerId', curr);
        return curr;
      }
    } catch (e) {}
    try {
      let curr = _st.cid;
      if (curr !== undefined && curr !== null && curr !== "") {
        console.log('_st.cid', curr);
        return curr;
      }
    } catch (e) {}
    // try {
    //   let curr = ShopifyAnalytics.lib.user().traits().uniqToken;
    //   if (curr !== undefined && curr !== null && curr !== "") {
    //     return curr;
    //   }
    // } catch (e) {}
    // return 6938496466979;
    return null;
  }

  function setAvatar(avatarUrl) {
    const avatarDom = document.querySelector('.thb-secondary-area-item.thb-secondary-myaccount') ||
      document.querySelector('.header__icon.header__icon--account')||
      document.querySelector('.header__icon-wrapper.tap-area.hidden-phone')||
      document.querySelector('.thb-mobile-account-link')||
      document.querySelector('.mobile-nav__footer .icon-text')
    if (avatarDom) {
      avatarDom.innerHTML = `<div class="spd-avatar"><img class="spd-avatar-img" src="${avatarUrl}"></div>`;
    }
  }

  window.LoyaltyFetch = LoyaltyFetch;
  window.getCustomerId = getCustomerId;
  window.setAvatar = setAvatar;
})();

/**
 * 全局监听事件上报
 */
// 邮件订阅
document.addEventListener(
  "DOMContentLoaded",
  function () {
    const subscribeForms = [
      ...document.querySelectorAll("form[action*=\\/contact]"),
    ];
    subscribeForms.forEach((form) => {
      form.addEventListener("submit", function (e) {
        const email = e.target.querySelector(
          "input[name=contact\\[email\\]]"
        ).value;
        if (!email) return;
        LoyaltyFetch({
          path: "taskCompleteCallBack",
          body: {
            taskId: "100002",
            shopifyEmail: email,
          },
        }).catch(console.error);
      });
    });
  },
  false
);

// 保存原始 fetch 方法
// const originalFetch = window.fetch;
// // 重写 fetch 方法
// window.fetch = async function (url, options) {
//   window.dispatchEvent(
//     new CustomEvent("fetch-intercepted", {
//       detail: {
//         url,
//         options,
//       },
//     })
//   );

//   // 调用原始 fetch 并返回结果
//   return originalFetch(url, options);
// };

// window.addEventListener("fetch-intercepted", function (e) {
//   const { url, options } = e.detail || {};
//   if (
//     url?.indexOf("https://loox.io/reviews") > -1 &&
//     url?.indexOf("/finish") != -1 &&
//     options?.method?.toUpperCase() == "POST"
//   ) {
//     const bodyObj = JSON.parse(options?.body || "{}");
//     const email = bodyObj?.data?.email;
//     if (!email) return;
//     LoyaltyFetch({
//       path: "taskCompleteCallBack",
//       body: {
//         taskId: "100003",
//         shopifyEmail: email,
//       },
//     }).catch(console.error);
//   }
// });
const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

